import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import useLenis from "@/hooks/useLenis";
import { AppProvider } from "@/context/AppState";
import { AdminAuthProvider } from "@/context/AdminAuth";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import EvaluationModal from "@/components/EvaluationModal";
import CompareBar from "@/components/CompareBar";
import Home from "@/pages/Home";
import Immobili from "@/pages/Immobili";
import ImmobileDetail from "@/pages/ImmobileDetail";
import Vacanze from "@/pages/Vacanze";
import VacanzaDetail from "@/pages/VacanzaDetail";
import CasaCrush from "@/pages/CasaCrush";
import MutuoCheck from "@/pages/MutuoCheck";
import CambioCasa from "@/pages/CambioCasa";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminVacanze from "@/pages/admin/AdminVacanze";
import GestionaleApp from "@/gestionale/GestionaleApp";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) { el.scrollIntoView({ behavior: "smooth" }); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function PublicApp() {
  useLenis();
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  return (
    <AppProvider>
      <div className="App grain min-h-screen bg-warm">
        <ScrollManager />
        <Header onValuation={openModal} />
        <main>
          <Routes>
            <Route path="/" element={<Home onValuation={openModal} />} />
            <Route path="/immobili" element={<Immobili />} />
            <Route path="/immobili/:id" element={<ImmobileDetail />} />
            <Route path="/vacanze" element={<Vacanze />} />
            <Route path="/vacanze/:id" element={<VacanzaDetail />} />
            <Route path="/casa-crush" element={<CasaCrush />} />
            <Route path="/mutuo" element={<MutuoCheck />} />
            <Route path="/cambio-casa" element={<CambioCasa />} />
          </Routes>
        </main>
        <Footer onValuation={openModal} />
        <EvaluationModal open={modalOpen} onOpenChange={setModalOpen} />
        <CompareBar />
        <Toaster position="top-center" richColors />
      </div>
    </AppProvider>
  );
}

function AdminSection() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route index element={<Navigate to="/gestionale" replace />} />
        <Route path="immobili/*" element={<Navigate to="/gestionale/immobili" replace />} />
        <Route path="richieste" element={<Navigate to="/gestionale/contatti" replace />} />
        <Route path="utenti" element={<Navigate to="/gestionale/utenti" replace />} />
        <Route element={<AdminLayout />}>
          <Route path="vacanze" element={<AdminVacanze />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </AdminAuthProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminSection />} />
        <Route path="/gestionale/*" element={<GestionaleApp />} />
        <Route path="/*" element={<PublicApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
